/**
 * @generated SignedSource<<65d6eb9227a499f5bfe528d12c36c40b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DealerLocation_item$data = {
  readonly address: {
    readonly displayCityStateCountry: string | null;
  } | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "DealerLocation_item";
};
export type DealerLocation_item$key = {
  readonly " $data"?: DealerLocation_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"DealerLocation_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealerLocation_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a47ee4a0c0f298a03d4499270d713e65";

export default node;
